import { followUps } from "@/mocks/reviews";

const statusTone: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800",
  accent: "bg-accent-100 text-accent-900",
  secondary: "bg-secondary-200 text-secondary-900",
};

export default function FollowUpSection() {
  return (
    <section id="followup" className="scroll-mt-28 bg-background-100 py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-6 lg:grid-cols-3">
          {/* 速报列表 */}
          <div className="lg:col-span-2">
            <div className="mb-2 flex items-center gap-2">
              <span className="h-5 w-1 bg-accent-500" />
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">后续进展速报</h2>
            </div>
            <p className="mb-5 text-xs text-foreground-600 md:text-sm">
              事件落地阶段的每一步动作都记录在此，方便你追平最末端的消息。
            </p>
            <div className="overflow-hidden border border-background-200 bg-background-50">
              {followUps.map((f, i) => (
                <div
                  key={f.id}
                  className="relative flex gap-4 border-b border-background-100 p-4 last:border-b-0 md:p-5"
                >
                  <div className="flex flex-col items-center">
                    <span className="mt-1.5 flex h-3 w-3 shrink-0 items-center justify-center rounded-full border-2 border-accent-400 bg-background-50" />
                    {i < followUps.length - 1 && <span className="mt-1 w-px flex-1 bg-background-200" />}
                  </div>
                  <div className="min-w-0 flex-1 pb-2">
                    <div className="flex flex-wrap items-center gap-2">
                      <span
                        className={`inline-flex items-center gap-1 rounded-sm px-1.5 py-0.5 text-[11px] font-medium ${statusTone[f.statusTone]}`}
                      >
                        <i className="ri-restart-line text-[11px]" /> {f.status}
                      </span>
                      <span className="flex items-center gap-1 text-[11px] text-foreground-500">
                        <i className="ri-time-line" /> {f.time}
                      </span>
                    </div>
                    <h3 className="mt-1.5 text-sm font-semibold text-foreground-950 md:text-base">{f.title}</h3>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{f.summary}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 投稿/纠错卡 */}
          <div className="flex flex-col gap-5">
            <div className="flex flex-col border border-background-200 bg-background-50 p-5">
              <span className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-white">
                  <i className="ri-quill-pen-line" />
                </span>
                深挖线索 / 澄清纠错
              </span>
              <p className="mt-3 text-xs leading-relaxed text-foreground-600">
                欢迎提供带完整上下文的线索，也欢迎对疑似拼接、掐头去尾的帖子上反证。我们只收能核验的内容。
              </p>
              <div className="mt-4 grid gap-2 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2">
                <button className="flex items-center justify-center gap-1 rounded-md bg-primary-500 px-3 py-2 text-sm font-semibold whitespace-nowrap text-background-50 hover:bg-primary-600">
                  <i className="ri-upload-2-line" /> 提交线索
                </button>
                <button className="flex items-center justify-center gap-1 rounded-md border border-background-200 bg-background-50 px-3 py-2 text-sm font-medium whitespace-nowrap text-foreground-800 hover:bg-background-100">
                  提交反证
                </button>
              </div>
            </div>
            <div className="border border-background-200 bg-foreground-950 p-5">
              <div className="flex items-center justify-between">
                <span className="flex items-center gap-1 font-heading text-base font-bold text-background-50">
                  <i className="ri-live-line text-accent-400" /> 追更进度
                </span>
                <span className="text-[11px] text-foreground-400">今日更新 12 条</span>
              </div>
              <p className="mt-2 text-[11px] leading-relaxed text-foreground-300">
                打开追更后，所关注事件的实锤、时间线与后续进展有新节点会第一时间提醒。
              </p>
              <div className="mt-3 flex flex-wrap gap-2">
                <a
                  href="#top"
                  className="inline-flex items-center gap-1 rounded-md bg-accent-500 px-3 py-2 text-xs font-semibold whitespace-nowrap text-background-50 hover:bg-accent-600"
                >
                  <i className="ri-notification-3-line" /> 开启追更
                </a>
                <a
                  href="#timeline"
                  className="inline-flex items-center gap-1 rounded-md border border-foreground-700 px-3 py-2 text-xs font-medium whitespace-nowrap text-background-50 hover:bg-foreground-800"
                >
                  查看在追时间线
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}